import { connect } from "react-redux";
import { connect as formikConnect } from "formik";

import Deal from "./Deal";

const mapStateToProps = ({ currentUser }) => ({
  currentUser,
});

export default connect(mapStateToProps)(formikConnect(Deal));
